import {
  ContentListAccordian,
  IconWrapper,
  IStyles,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { CheckBox } from '@mui/icons-material';
import { Box, Button, Modal, Typography, useMediaQuery } from '@mui/material';
import { AssessmentTask } from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  QuestionModuleMap,
  TaskMetaInfo,
} from '@protos/learning_management/lms.db_pb';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import React from 'react';
const styles: IStyles = {
  root: {
    width: { md: '100%' },
    border: '1px solid #E0E2E4',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
    padding: { xs: pxToRem(10), md: pxTovW(15) },
    marginY: { xs: pxToRem(10), md: pxTovW(10) },
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    // justifyContent: 'center',
    // alignItems: 'center',
  },
};
interface IProps {
  assessmentTaskInfo?: TaskMetaInfo;
  editClickHandler?: () => void;
  questionModuleMap?: QuestionModuleMap[];
}
export default function SelectedChapters(props: IProps) {
  const { fa_selected_chapter_data } = useAppSelector(
    (state) => state.assessment
  );
  const { assessmentTaskInfo, editClickHandler, questionModuleMap } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  if (!assessmentTaskInfo || !assessmentTaskInfo.chapterInfo) {
    return null;
  }

  const chapterCount: Record<number, number> = {};
  const topicCount: Record<number, number> = {};
  assessmentTaskInfo.chapterInfo.chapterTopicsInfo?.forEach((chapter) => {
    const chapterId = chapter.chapterId;
    const topics = chapter.topicInfo.map((t) => t.topicId);
    topics.forEach((topicId) => {
      const questionCount = questionModuleMap?.filter(
        (q) => q.topicId === topicId
      ).length;
      topicCount[topicId] = (topicCount[topicId] || 0) + (questionCount || 0);
      chapterCount[chapterId] =
        (chapterCount[chapterId] || 0) + (questionCount || 0);
    });
    const questionCount = questionModuleMap?.filter(
      (q) =>
        q.chapterId === chapterId &&
        ((q.topicId && !topics.includes(q.topicId)) || !q.topicId)
    ).length;
    chapterCount[chapterId] =
      (chapterCount[chapterId] || 0) + (questionCount || 0);
  });

  return (
    <Box sx={styles.root}>
      {assessmentTaskInfo?.chapterInfo?.chapterTopicsInfo?.length > 0 ? (
        <>
          <Box
            sx={{
              display: 'flex',
              marginBottom: { md: pxTovW(20) },
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant={isMobile ? 'h2' : 'h3'}
              sx={{
                marginBotttom: { xs: pxToRem(15) },
                fontWeight: 'bold',
              }}
            >
              What's Covered
            </Typography>

            {fa_selected_chapter_data && editClickHandler && (
              <Button
                sx={{
                  display: {
                    xs: 'none',
                    md: 'flex',
                  },
                  p: '0',
                  // justifyContent: 'end',
                  maxContentWidth: 'fit-content',
                  alignSelf: 'flex-end',
                  cursor: 'pointer',
                }}
                onClick={editClickHandler}
              >
                <IconWrapper
                  name="edit"
                  type="png"
                  parentFolder="icons"
                  size="large"
                />
              </Button>
            )}
          </Box>
          {assessmentTaskInfo.chapterInfo?.chapterTopicsInfo.map(
            (chapter, index) => (
              <Box
                key={index}
                sx={{
                  width: { xs: '100%', md: pxTovW(500), lg: pxTovW(400) },
                  display: { md: 'flex' },
                  alignitems: 'flex-start',
                  gap: { xs: pxToRem(10), md: pxTovW(10) },
                }}
              >
                <ContentListAccordian
                  key={index}
                  variant="medium"
                  HeaderContent={
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        gap: { xs: pxToRem(10), md: pxTovW(10) },
                        paddingY: { xs: pxToRem(5) },
                      }}
                    >
                      <IconWrapper
                        name="correct"
                        size="md"
                        type="png"
                        parentFolder="icons"
                        customSx={{
                          height: {
                            xs: pxToRem(20),
                            md: pxTovW(25),
                            lg: pxTovW(20),
                          },
                          flexShrink: 0,
                        }}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: { xs: pxToRem(5), md: pxTovW(8) },
                          flexGrow: 1,
                          minWidth: 0,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: pxToRem(5),
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{
                              fontWeight: 'bold',
                              overflow: 'hidden',
                              marginY: 'auto',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {`${
                              chapter.chapterNo ? `${chapter.chapterNo}.` : ''
                            } ${chapter.name}`}{' '}
                          </Typography>
                          {!!chapterCount[chapter.chapterId] && (
                            <Typography
                              variant={'h4'}
                              sx={{ fontWeight: 'bold' }}
                            >
                              [{chapterCount[chapter.chapterId]}]
                            </Typography>
                          )}
                        </Box>
                        <Typography color={'primary'} variant={'h5'}>
                          {chapter.topicInfo.length} Topics
                        </Typography>
                      </Box>
                    </Box>
                  }
                  expandDisabled={false}
                  // handleExpandmore={() => console.log('clicked')}
                  // handleExpandless={() => console.log('clicked', chapter.chapterId)}
                  // open={true}
                  listRightPadding={'10px'}
                  ListItemArray={chapter.topicInfo.map((topic) => (
                    <Box
                      sx={{
                        width: '100%',
                        height: { xs: '30px', md: '25px' },
                        display: 'flex',
                        gap: pxTovW(10),
                        alignItems: 'center',
                        paddingY: pxTovW(10),
                      }}
                    >
                      {/* <CheckBox
                          sx={{ height: '15px', width: '15px' }}
                          color="primary"
                        /> */}
                      <Box
                        sx={{
                          display: 'flex',
                          gap: pxToRem(5),
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: 'bold',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {topic.name}
                        </Typography>
                        {!!topicCount[topic.topicId] && (
                          <Typography
                            variant={'h4'}
                            sx={{ fontWeight: 'bold' }}
                          >
                            [{topicCount[topic.topicId]}]
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  ))}
                />
              </Box>
            )
          )}
        </>
      ) : (
        <></>
      )}
    </Box>
  );
}
